import request from '../request';

import querystring from 'querystring';

export default async function postRequest(baseUrl, params = '', body) {
	if (params) params = `?${querystring.stringify(params)}`;
	let response = await request({
		method: 'post',
		url: `${baseUrl}${params}`,
		data: body,
	});
	return response;
}
